import React from "react";
import { IconProps } from "./IconProps";

const ChatCircleTextIcon: React.FC<IconProps> = ({
  size,
  thickness,
  ariaLabel,
  color = "currentColor",
}) => {
  switch (`${size}${thickness}`) {
    case "24Reg":
      return (
        <svg
          aria-label={ariaLabel}
          fill={color}
          width="24"
          height="24"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.75 10.5C15.75 10.6989 15.671 10.8897 15.5303 11.0303C15.3897 11.171 15.1989 11.25 15 11.25H9C8.80109 11.25 8.61032 11.171 8.46967 11.0303C8.32902 10.8897 8.25 10.6989 8.25 10.5C8.25 10.3011 8.32902 10.1103 8.46967 9.96967C8.61032 9.82902 8.80109 9.75 9 9.75H15C15.1989 9.75 15.3897 9.82902 15.5303 9.96967C15.671 10.1103 15.75 10.3011 15.75 10.5ZM15 12.75H9C8.80109 12.75 8.61032 12.829 8.46967 12.9697C8.32902 13.1103 8.25 13.3011 8.25 13.5C8.25 13.6989 8.32902 13.8897 8.46967 14.0303C8.61032 14.171 8.80109 14.25 9 14.25H15C15.1989 14.25 15.3897 14.171 15.5303 14.0303C15.671 13.8897 15.75 13.6989 15.75 13.5C15.75 13.3011 15.671 13.1103 15.5303 12.9697C15.3897 12.829 15.1989 12.75 15 12.75ZM21.75 12C21.7504 13.6833 21.3149 15.338 20.486 16.8031C19.6572 18.2682 18.4631 19.4938 17.02 20.3605C15.577 21.2272 13.9341 21.7055 12.2514 21.7489C10.5686 21.7923 8.9033 21.3993 7.4175 20.6081L4.22531 21.6722C3.96102 21.7603 3.6774 21.7731 3.40624 21.7091C3.13509 21.6451 2.88711 21.5069 2.69011 21.3099C2.49311 21.1129 2.35486 20.8649 2.29087 20.5938C2.22688 20.3226 2.23967 20.039 2.32781 19.7747L3.39187 16.5825C2.69639 15.2749 2.30793 13.826 2.256 12.3459C2.20406 10.8658 2.49001 9.39325 3.09213 8.04012C3.69425 6.687 4.59672 5.48882 5.73105 4.53655C6.86537 3.58428 8.20173 2.90295 9.63869 2.54426C11.0756 2.18557 12.5754 2.15895 14.0242 2.46644C15.473 2.77392 16.8327 3.40742 18.0001 4.31885C19.1675 5.23027 20.1119 6.39567 20.7616 7.72659C21.4114 9.0575 21.7494 10.5189 21.75 12ZM20.25 12C20.2496 10.7345 19.9582 9.48603 19.3981 8.3512C18.838 7.21637 18.0244 6.22559 17.0201 5.45553C16.0159 4.68547 14.8479 4.15675 13.6067 3.9103C12.3654 3.66384 11.084 3.70625 9.86178 4.03425C8.63951 4.36224 7.50909 4.96702 6.55796 5.8018C5.60682 6.63659 4.86049 7.67899 4.37668 8.84837C3.89288 10.0177 3.68458 11.2828 3.7679 12.5455C3.85122 13.8083 4.22393 15.035 4.85719 16.1306C4.91034 16.2226 4.94334 16.3248 4.954 16.4305C4.96467 16.5362 4.95276 16.643 4.91906 16.7437L3.75 20.25L7.25625 19.0809C7.33262 19.0549 7.41275 19.0416 7.49344 19.0416C7.62516 19.0418 7.7545 19.0767 7.86844 19.1428C9.12263 19.8685 10.5458 20.251 11.9948 20.2519C13.4438 20.2528 14.8674 19.8721 16.1225 19.148C17.3776 18.424 18.4199 17.3821 19.1445 16.1273C19.869 14.8725 20.2503 13.449 20.25 12Z"
            fill={color}
          />
        </svg>
      );
    case "32Reg":
      return (
        <svg
          aria-label={ariaLabel}
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 256 256"
        >
          <path d="M168,112a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8,8,0,0,1,168,112Zm-8,24H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Zm72-8A104,104,0,0,1,79.12,219.82L45.07,231.17a16,16,0,0,1-20.24-20.24l11.35-34.05A104,104,0,1,1,232,128Zm-16,0A88,88,0,1,0,51.81,172.06a8,8,0,0,1,.66,6.54L40,216,77.4,203.53a7.85,7.85,0,0,1,2.53-.42,8,8,0,0,1,4,1.08A88,88,0,0,0,216,128Z"></path>
        </svg>
      );
    default:
      return null;
  }
};

export default ChatCircleTextIcon;
